/* eslint-disable eqeqeq */
import { Button } from "../../../../components/ui/button";
import {
  InputOTP,
  InputOTPGroup,
  InputOTPSeparator,
  InputOTPSlot,
} from "../../../../components/ui/input-otp";
import React, { useLayoutEffect, useState } from "react";
import { API, get, post } from "../../../../config";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Mail } from "lucide-react";
import { useStepper } from "../../../../components/ui/stepper";
import { useOrganization } from "../../../../lib/context/OrganisationContext";
import { useUser } from "../../../../lib/context/UserContext";

const Step4 = ({ verifyUrl, setLoading, backupEmail }) => {
  const [searchParams] = useSearchParams();
  const [validator, setValidator] = useState(false);
  const [email, setEmail] = useState("");
  const [emailVerifyCode, setEmailVerifyCode] = useState("");
  const navigate = useNavigate();
  const { prevStep } = useStepper();

  const { updateOrganizationList } = useOrganization();
  const { updateUserData } = useUser();

  useLayoutEffect(() => {
    const test = async () => {
      const { data } = await get(API.GET_USER_PROFILE);
      if (data) {
        updateUserData(data?.data);
      }
      if (data?.backup_email) setEmail(data.backup_email);
    };
    if (!backupEmail) {
      test();
    } else {
      setEmail(backupEmail);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const changeAuthenticationCode = (event) => {
    if (validator) {
      setValidator(false);
    }
    setEmailVerifyCode(event);
  };

  const verifyEmail = async () => {
    localStorage.setItem("ts-auth-tfa", 2);
    if (!localStorage.getItem("Name")) {
      let userData = await get(API.GET_USER_PROFILE);
      if (userData) {
        updateUserData(userData?.data?.data);
      }

      if (userData) {
        updateOrganizationList(
          userData?.data?.data?.user_organizations &&
            userData?.data?.data?.user_organizations?.length > 0
            ? userData?.data?.data?.user_organizations?.map((item) => {
                return {
                  ...item?.organization,
                  value: item?.organization?.id ? item?.organization?.id : "",
                  label: item?.organization?.business_name
                    ? item?.organization?.business_name
                    : "",
                };
              })
            : []
        );
        const { first_name, profile_pic, last_name, id, role } =
          userData?.data?.data;
        localStorage.setItem(
          "Name",
          first_name ? `${first_name} ${last_name}` : last_name
        );
        localStorage.setItem("ProfilePhoto", profile_pic);
        localStorage.setItem("role", role?.name);
        localStorage.setItem("roleType", role?.type);
        localStorage.setItem("role-slug", role?.slug);
        localStorage.setItem("userId", id);
        localStorage.setItem("EmailVerification", 1);
        localStorage.setItem("ts-auth-tfa", 2);

        let is_subscribe = userData?.data?.subscribed;
        let singleTrust = userData?.data?.single_trust;
        let singleTrustId = userData?.data?.trust_id;
        is_subscribe == 1 && singleTrust == 1
          ? navigate(`/trusts/${singleTrustId}/dashboard`)
          : is_subscribe !== undefined && is_subscribe == 0
          ? navigate("/general-settings?tab=subscription")
          : navigate("/trusts");
      } else {
        var error = {};

        error["bt_error"] =
          "There is some issue with request, please try after some time.";
      }
    } else {
      if (searchParams.get("page") === "back") {
        localStorage.setItem("ts-auth-tfa", 2);
        navigate(-1);
      }
    }
  };

  const confirmCode = async (e) => {
    e.preventDefault();
    let params = {};
    if (verifyUrl === "/disable-2fa") {
      params = { code: emailVerifyCode, id: 1 };
    } else {
      params = { code: emailVerifyCode };
    }
    setLoading(true);
    post(verifyUrl, params)
      .then(async () => {
        localStorage.setItem("isOTPVerified", "true");
        verifyEmail();
        setValidator(false);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
        setValidator(true);
      });
  };

  return (
    <form
      onSubmit={confirmCode}
      className="flex flex-col items-center justify-center"
    >
      <p className="flex items-center text-lg font-bold">
        <span className="mr-2">
          <Mail height={30} width={30} />
        </span>
        Check your backup email and enter the code
      </p>
      <p className="pb-3">
        {`Enter the code sent to ${email} to confirm your email address`}
      </p>
      <div className="flex flex-col items-center justify-center pb-3">
        <InputOTP
          maxLength={6}
          onChange={(e) => changeAuthenticationCode(e)}
          name="code"
          id="code"
          value={emailVerifyCode}
        >
          <InputOTPGroup>
            <InputOTPSlot index={0} />
            <InputOTPSlot index={1} />
            <InputOTPSlot index={2} />
          </InputOTPGroup>
          <InputOTPSeparator />
          <InputOTPGroup>
            <InputOTPSlot index={3} />
            <InputOTPSlot index={4} />
            <InputOTPSlot index={5} />
          </InputOTPGroup>
        </InputOTP>
      </div>
      <div className="flex gap-2">
        <Button type="submit">Confirm</Button>
        <Button variant="outline" size="default" onClick={() => prevStep()}>
          Back
        </Button>
      </div>
    </form>
  );
};

export default Step4;
